import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ChevronRight } from "lucide-react";
import { settle } from "./settlementApi";

// Dashboard list of failed or stuck settlements.
export function SettlementAttentionCard() {
  const [items, setItems] = useState(null);
  useEffect(() => { settle.attention().then((d) => setItems(d.items)).catch(() => setItems([])); }, []);
  if (!items?.length) return null;
  return (
    <div className="mb-10 border border-red-200 bg-red-50/40" data-testid="settlement-attention-card">
      <div className="flex items-center gap-2 px-5 py-3 border-b border-red-200 text-[11px] uppercase tracking-[0.14em] text-red-800">
        <AlertTriangle className="w-4 h-4" /> Settlements needing attention ({items.length})
      </div>
      <ul className="divide-y divide-red-100">
        {items.map((it) => (
          <li key={it.key}>
            <Link to={`/admin/bookings?q=${encodeURIComponent(it.booking_id)}`} className="flex items-center justify-between px-5 py-3 hover:bg-white/60 transition-colors" data-testid={`attention-item-${it.booking_id}`}>
              <div className="text-[12px]">
                <div className="text-[#282828] font-medium">{it.customer_name || "Customer"} · {it.item || it.booking_id}</div>
                <div className="text-[#676664]/70">
                  {it.status === "pending" ? (it.stuck ? "Stuck — safe to retry or cancel" : "Saving now…") : `Failed at ${it.failed_step || "?"}`}
                  {it.payments_kept.length ? ` · ${it.payments_kept.length} card payment(s) kept` : ""}
                  {it.needs_manual_review ? " · needs manual review" : ""}
                </div>
              </div>
              <ChevronRight className="w-4 h-4 text-[#676664]/40" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
